import { fetchFromAPI } from 'utils/api';

export const getFeedRations = () => {
  return fetchFromAPI('/admin/feed_rations')
    .then(({ resources }) => resources)
    .catch((response) => {
      throw response;
    });
};

export const getFeedRation = (id) => {
  return fetchFromAPI(`/admin/feed_rations/${id}`)
    .then(({ resource }) => resource)
    .catch((response) => {
      throw response;
    });
};

export const createFeedRation = (resource) => {
  return fetchFromAPI('/admin/feed_rations', { method: 'post', body: JSON.stringify({ resource }) })
    .then((response) => response.resource)
    .catch((response) => {
      throw response;
    });
};

export const updateFeedRation = (id, resource) => {
  return fetchFromAPI(`/admin/feed_rations/${id}`, { method: 'put', body: JSON.stringify({ resource }) })
    .then((response) => response.resource)
    .catch((response) => {
      throw response;
    });
};

export const deleteFeedRation = (id) => {
  return fetchFromAPI(`/admin/feed_rations/${id}`, { method: 'delete' })
    .catch((response) => {
      throw response;
    });
};

export const disableFeedRation = (id) => {
  return fetchFromAPI(`/admin/feed_rations/${id}/disable`, { method: 'put' })
    .then(({ resource }) => resource)
    .catch((response) => {
      throw response;
    });
};

export const enableFeedRation = (id) => {
  return fetchFromAPI(`/admin/feed_rations/${id}/enable`, { method: 'put' })
    .then(({ resource }) => resource)
    .catch((response) => {
      throw response;
    });
};

export const updateFeedRationsSequence = (feed_ration_ids) => {
  return fetchFromAPI('/admin/feed_rations/update_sequence', {
    method: 'put',
    body: JSON.stringify({ resource: { feed_ration_ids } }),
  })
    .then(({ resources }) => resources)
    .catch((response) => {
      throw response;
    });
};

// Medication picker source: active products the company tagged as "Feed"
export const getFeedTreatmentProducts = (params) => {
  return fetchFromAPI('/admin/treatment_products', { params: { ...params, feed: true, status: 'active' } })
    .catch((response) => {
      throw response;
    });
};
